import{jsx as r}from"react/jsx-runtime";import s from"./assets/page-title.module.scss";const t=({title:e})=>e?r("h1",{className:s.pageTitle,children:e}):null;export{t as PageTitle};
